var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpFaqIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 20.5,
    fill: "#FCF2F3",
    stroke: "url(#paint0_linear_5353_40429)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 22.5V24H29.5V22.5H31ZM29 17.5H27.5V17C27.5 16.2044 27.8161 15.4413 28.3787 14.8787C28.9413 14.3161 29.7044 14 30.5 14C31.2956 14 32.0587 14.3161 32.6213 14.8787C33.1839 15.4413 33.5 16.2044 33.5 17C33.5 17.97 33 18.88 32.21 19.41L31.91 19.6C31.34 20 31 20.61 31 21.3V21.5H29.5V21.3C29.5 20.11 30.1 19 31.09 18.35L31.38 18.16C31.77 17.9 32 17.47 32 17C32 16.6022 31.842 16.2206 31.5607 15.9393C31.2794 15.658 30.8978 15.5 30.5 15.5C30.1022 15.5 29.7206 15.658 29.4393 15.9393C29.158 16.2206 29 16.6022 29 17V17.5ZM19.5 21C22.17 21 27.5 22.34 27.5 25V28H11.5V25C11.5 22.34 16.83 21 19.5 21ZM19.5 12C20.5609 12 21.5783 12.4214 22.3284 13.1716C23.0786 13.9217 23.5 14.9391 23.5 16C23.5 17.0609 23.0786 18.0783 22.3284 18.8284C21.5783 19.5786 20.5609 20 19.5 20C18.4391 20 17.4217 19.5786 16.6716 18.8284C15.9214 18.0783 15.5 17.0609 15.5 16C15.5 14.9391 15.9214 13.9217 16.6716 13.1716C17.4217 12.4214 18.4391 12 19.5 12ZM19.5 22.9C16.53 22.9 13.4 24.36 13.4 25V26.1H25.6V25C25.6 24.36 22.47 22.9 19.5 22.9ZM19.5 13.9C18.943 13.9 18.4089 14.1212 18.0151 14.5151C17.6212 14.9089 17.4 15.443 17.4 16C17.4 16.557 17.6212 17.0911 18.0151 17.4849C18.4089 17.8788 18.943 18.1 19.5 18.1C20.057 18.1 20.5911 17.8788 20.9849 17.4849C21.3788 17.0911 21.6 16.557 21.6 16C21.6 15.443 21.3788 14.9089 20.9849 14.5151C20.5911 14.1212 20.057 13.9 19.5 13.9Z",
    fill: "#C7222A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5353_40429",
    x1: 21.5,
    y1: 1,
    x2: 21.5,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpFaqIcon);
export default __webpack_public_path__ + "static/media/HelpFAQIcon.7f5fc5c4aa37385b7d0532f709384373.svg";
export { ForwardRef as ReactComponent };